import { render, staticRenderFns } from "./NavigationButton.vue?vue&type=template&id=f8234a04&scoped=true&"
import script from "./NavigationButton.vue?vue&type=script&lang=js&"
export * from "./NavigationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8234a04",
  null
  
)

export default component.exports